import React, { useEffect } from 'react';

/**
 *
 * @param elementChildren
 * @param quizKitButtonClass
 * @param quizKitId
 * @param quizKitResultClass
 * @param quizKitAddAllButtonClass
 * @param quizKitMinusClass
 * @param quizKitPlusClass
 * @param quizKitQtyInputClass
 * @param addToCart
 * @returns {JSX.Element}
 * @constructor
 */
const QuizKitCustomLogic = ({
  elementChildren,
  quizKitButtonClass,
  quizKitId,
  quizKitResultClass,
  quizKitAddAllButtonClass,
  quizKitMinusClass,
  quizKitPlusClass,
  quizKitQtyInputClass,
  addToCart,
}) => {
  useEffect(() => {
    // Flag to track quantity multiplier
    let multiplier = 1;

    // Check for Quiz Kit logic loaded
    const loader = setInterval(() => {
      if (document.getElementById('quiz-kit-container')) {
        clearInterval(loader);
        quizCustomLogic();
      }
    }, 50);

    // Apply our own logic
    const quizCustomLogic = () => {
      // The results container
      const results = document.getElementById(`quiz-kit-results-${quizKitId}`);

      if (results) {
        const addAllButton = document.querySelector(`button[class*="${quizKitAddAllButtonClass}"]`);
        const selectedProducts = document.querySelectorAll(`div[class*="${quizKitResultClass}"]`);

        // If we've went down the path of 2 Meeting Owl Pro's being recommended
        if (multiplier > 1) {
          [...selectedProducts].map((el) => {
            const minus = el.querySelector(`span[class*="${quizKitMinusClass}"]`);
            const plus = el.querySelector(`span[class*="${quizKitPlusClass}"]`);
            const inputQuantity = el.querySelector(`input[class*="${quizKitQtyInputClass}"]`);
            // Override Quiz Kit minimum input value
            inputQuantity.min = 0;

            // Set the initial value upon landing on results
            inputQuantity.valueAsNumber =
              el.querySelector('h3').innerText === 'Meeting Owl Pro' ? 2 : 1;

            // Check if any of the quantities are 0
            const qtyAdjustment = setInterval(() => {
              const button = el.querySelector('button');
              button.disabled = inputQuantity.valueAsNumber < 1;
            }, 50);

            el.querySelector('button').addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              const result = e.currentTarget.closest(`div[class*="${quizKitResultClass}"]`);
              const title = result.querySelector('h3').innerText;

              const properties = {
                id: e.currentTarget.dataset.variantId,
                // Only add 2 of the Meeting Owl Pro, 1 of everything else
                quantity: Number(inputQuantity.value),
              };

              addToCart(properties, title);
            });

            minus.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              --inputQuantity.value;
            });

            plus.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              ++inputQuantity.value;
            });
          });

          // Find the product whose quantity we want to increase
          const filteredProduct = [...selectedProducts].filter(
            (product) => product.querySelector('h3').innerText === 'Meeting Owl Pro',
          );

          // Update the product quantity
          filteredProduct.map((product) => (product.querySelector('input').value = '2'));

          addAllButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const allItems = [...selectedProducts].map((el) => {
              const addButton = el.querySelector('button');
              const input = el.querySelector(`input[class*="${quizKitQtyInputClass}"]`);

              return {
                id: addButton.dataset.variantId,
                quantity: Number(input.value),
              };
            });

            addToCart(
              allItems,
              allItems.every((item) => item.quantity === 0) ? 'Nothing' : 'Recommended Products',
            );
          });
        } else {
          [...selectedProducts].map((el) => {
            const minus = el.querySelector(`span[class*="${quizKitMinusClass}"]`);
            const plus = el.querySelector(`span[class*="${quizKitPlusClass}"]`);
            const inputQuantity = el.querySelector(`input[class*="${quizKitQtyInputClass}"]`);
            inputQuantity.min = 0;
            inputQuantity.value = 1;

            el.querySelector('button').addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              const result = e.currentTarget.closest(`div[class*="${quizKitResultClass}"]`);
              const title = result.querySelector('h3').innerText;

              const properties = {
                id: e.currentTarget.dataset.variantId,
                quantity: Number(inputQuantity.value),
              };

              addToCart(properties, title);
            });

            minus.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              --inputQuantity.value;
            });

            plus.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              ++inputQuantity.value;
            });
          });

          addAllButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const allItems = [...selectedProducts].map((el) => {
              const addButton = el.querySelector('button');

              return {
                id: addButton.dataset.variantId,
                quantity: 1,
              };
            });

            addToCart(
              allItems,
              allItems.every((item) => item.quantity === 0) ? 'Nothing' : 'Recommended Products',
            );
          });
        }
      } else {
        const buttons = document.querySelectorAll(`button[class*="${quizKitButtonClass}"]`);

        buttons.forEach((button) =>
          button.addEventListener('click', (e) => {
            setTimeout(quizCustomLogic, 500);

            if (e.currentTarget.querySelector('h3').innerText === '4+') {
              multiplier = 2;
            }
          }),
        );
      }
    };
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: elementChildren }}></div>;
};

export default QuizKitCustomLogic;
